import { render, staticRenderFns } from "./FeedCard.vue?vue&type=template&id=0048c14e&scoped=true"
import script from "./FeedCard.vue?vue&type=script&lang=js"
export * from "./FeedCard.vue?vue&type=script&lang=js"
import style0 from "./FeedCard.vue?vue&type=style&index=0&id=0048c14e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0048c14e",
  null
  
)

export default component.exports